import {useState} from "react";
import {useSearchParams} from "react-router-dom";
import { FraudEngineList } from "./FraudEngineList";
import { FraudEngineTwoPagerList } from "./FraudEngineTwoPagerList";

const FRAUD_TABS = [
  {
    tabIndex: 0,
    tabId: "fraud-book-a-demo",
    tabName: "Fraud-Book a Demo",
  },
  {
    tabIndex: 1,
    tabId: "fraud-2-pager-asset",
    tabName: "Fraud-2-Pager-Asset",
  },
];

const FraudEngineFramework = (): JSX.Element => {
  const [fraudTabs, setFraudTabs] = useState(FRAUD_TABS);
  const [searchParams, setSearchParams] = useSearchParams({tabIndex: "0"});

  const handleTabChange = (tabId: number) => {
    setSearchParams((params) => {
      params.set("tabIndexTwo", JSON.stringify(tabId));
      return params;
    });
  };
  const tabIndex = searchParams.get("tabIndexTwo");
  const parsedTabIndex = tabIndex ? JSON.parse(tabIndex) : 0;

  return (
    <div className="main-container podcasts">
      <div className="podcasts-tab">
        {fraudTabs.map((tab, index) => {
          const {tabIndex, tabId, tabName} = tab;

          return (
            <div
              key={tabId}
              className={`item ${tabIndex === parsedTabIndex ? "active" : ""}`}
              onClick={() => handleTabChange(tabIndex)}>
              {tabName}
            </div>
          );
        })}
      </div>
      <>
        {parsedTabIndex === 0 && <FraudEngineList/>}
        {parsedTabIndex === 1 && <FraudEngineTwoPagerList/>}
      </>
    </div>
  );
};

export default FraudEngineFramework;
